import request from '../untils/request';

export const systemRedisCacheConfigListApi = params => {
  return request({
    url: '/system/redis-cache/config-list',
    params,
  });
};

export const systemRediscacheApi = params => {
  return request({
    url: '/system/redis-cache/index',
    params,
  });
};

export const systemRedisCacheAddMachineApi = params => {
  return request({
    url: '/system/redis-cache/add-machine',
    params,
  });
};

export const systemRedisCacheMachineApi = params => {
  return request({
    url: '/system/redis-cache/machine-status',
    params,
  });
};

export const systemRedisOrderEnableConfigApi = params => {
  return request({
    url: '/system/redis-cache/enable-config',
    params,
  });
};

export const systemDelRedisCacheApi = params => {
  return request({
    url: '/system/redis-cache/delete-config',
    params,
  });
};

export const systemRedisCacheEditConfigApi = params => {
  return request({
    url: '/system/redis-cache/edit-config',
    params,
  });
};

export const systemRedisCacheGrayEnableConfigApi = params => {
  return request({
    url: '/system/redis-cache/gray-enable-config',
    params,
  });
};

export const systemRedisCacheEditWeightApi = params => {
  return request({
    url: '/system/redis-cache/edit-weight',
    params,
  });
};

export const systemRedisOrderClearCache = params => {
  return request({
    url: '/system/redis-order-config/clear-cache',
    params,
  });
};

export const systemRedisOrderClearBigSwitchCache = params => {
  return request({
    url: '/system/redis-order-config/clear-big-switch-cache',
    params,
  });
};

export const systemRedisOrderClearGraySwitchCache = params => {
  return request({
    url: '/system/redis-order-config/clear-gray-switch-cache',
    params,
  });
};

export const systemRedisCacheClearCache = params => {
  return request({
    url: '/system/redis-cache/clear-cache',
    params,
  });
};

export const systemCacheSearchClear = params => {
  return request({
    url: '/system/cache-search/clear',
    params,
  });
};

export const systemCacheSearchRedis = params => {
  return request({
    url: '/system/cache-search/search-redis',
    params,
  });
};

export const systemCacheSearchFileCache = params => {
  return request({
    url: '/system/cache-search/search-file-cache',
    params,
  });
};

export const systemCacheSearchKeywords = params => {
  return request({
    url: '/system/cache-search/keywords',
    params,
  });
};

export const systemRedisCartConfigApi = params => {
  return request({
    url: '/system/redis-cart/index',
    params,
  });
};

export const systemRedisCartAddMachineApi = params => {
  return request({
    url: '/system/redis-cart/add-machine',
    params,
  });
};

export const systemRedisCartGrayTestSaveApi = params => {
  return request({
    url: '/system/redis-cart/gray-test-save',
    params,
  });
};

export const systemRedisCartFrequentMachineApi = params => {
  return request({
    url: '/system/redis-cart/machine-status',
    params,
  });
};

export const systemRedisCartGrayDelAllRecordApi = params => {
  return request({
    url: '/system/gray-test/delete-record-all',
    params,
  });
};

export const systemRedisCartEnableConfigApi = params => {
  return request({
    url: '/system/redis-cart/enable-config',
    params,
  });
};

export const systemRedisCartConfigListApi = params => {
  return request({
    url: '/system/redis-cart/config-list',
    params,
  });
};

export const systemRedisCartSwitchSaveApi = params => {
  return request({
    url: '/system/redis-cart/switch-save',
    params,
  });
};

export const systemRedisCartPanelTabsApi = params => {
  return request({
    url: '/system/redis-cart/stat-tabs',
    params,
  });
};

export const systemRedisCartPanelDetailApi = params => {
  return request({
    url: '/system/redis-cart/redis-stat',
    params,
  });
};

export const systemRedisCartCleanGrayRecordApi = params => {
  return request({
    url: '/system/redis-cart/clean-gray-record',
    params,
  });
};

export const systemRedisCartDelGrayRecordApi = params => {
  return request({
    url: '/system/redis-cart/delete-config',
    params,
  });
};

export const systemRedisCartEditConfigApi = params => {
  return request({
    url: '/system/redis-cart/edit-config',
    params,
  });
};

export const systemRedisCartDestoryConfigApi = params => {
  return request({
    url: '/system/redis-cart/destroy-redis',
    params,
  });
};

export const systemRedisCartClearCache = params => {
  return request({
    url: '/system/redis-cart/clear-cache',
    params,
  });
};

export const systemRedisCartClearBigSwitchCache = params => {
  return request({
    url: '/system/redis-cart/clear-big-switch-cache',
    params,
  });
};

export const systemRedisCartClearGraySwitchCache = params => {
  return request({
    url: '/system/redis-cart/clear-gray-switch-cache',
    params,
  });
};

export const paymentChannelListApi = () => {
  return request({
    url: '/system/pay-channel/list',
    params: {},
  });
};
